import { Entity, IField } from "@/app/fields/types";

export const groupByFormSection = <T extends Entity>(arr: IField<T>[]) =>
  arr.reduce((result, obj) => {
    const key = obj.form_section;
    if (!result[key]) {
      result[key] = [];
    }
    result[key].push(obj);
    return result;
  }, {} as { [key: string]: IField<T>[] });
